export default "__VITE_ASSET__a0e18b3d__"